import styled from "styled-components";
import { Grid } from "@material-ui/core";

export const StyledGrid = styled(Grid)`
  .display-flex-end {
    display: flex;
    justify-content: flex-end;
  }
`;
